import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { appendModel } from '../../../../../features/site/siteSlice'

import { serviceMap } from '../../../../utils/common'
import MicrosoftClaimCard from '../../../Admin/ServiceTypes/MicrosoftAds'

import ServiceCardBase from '../../ServiceCardBase'

function Microsoft({ onSave, onCancel}){
    const dispatch = useDispatch()
    
    const model = useSelector(state => state.site.model)
    const oauthTokens = useSelector(state => state.session.oauthTokens)

    const site = model?.sites[model.siteActiveIdx]

    const { siteForm } = model

    const editSite = async() => {
        await dispatch(appendModel({
            siteForm: {
                ...siteForm,
                attr: {
                    ...siteForm.attr,
                    accounts: {
                        ...(siteForm?.attr?.accounts ?? {}),
                        bing: undefined
                    }
                }
            }
        }))
    }

    return <ServiceCardBase 
        title="Microsoft Ads" 
        header="Microsoft Ads" 
        description=" "
        image={serviceMap.bing.img}>
            <MicrosoftClaimCard design="onboarding" />
            <div class="d-flex flex-row-reverse justify-content-between">
                <div>
                    {siteForm?.attr?.accounts?.bing && localStorage.getItem("bingSelection") !== null && <button className="mr-3 btn btn-lg btn-outline-primary" onClick={() => editSite()}>
                        Edit
                    </button>}
                    {siteForm?.attr?.accounts?.bing && oauthTokens?.bing ? <button className="btn btn-lg btn-primary" onClick={async() => {
                        await onSave("bing")
                    }}>Save</button> : <span></span>}
                </div>
                {(!siteForm?.attr?.accounts?.bing || localStorage.getItem("bingSelection") === null) && <button id="msAdsClaimLater" className="btn btn-lg btn-link" onClick={() =>onCancel("bing")}>Claim Later</button>}
            </div>
    </ServiceCardBase>
}

export default Microsoft